// Redirect configuration for already indexed pages
export interface RedirectRule {
  from: string;
  to: string;
  status?: 301 | 302 | 307 | 308; // HTTP status codes
  permanent?: boolean; // For client-side redirects
  isFullUrl?: boolean; // Whether this is a full URL redirect
}

export const redirectRules: RedirectRule[] = [
  // WordPress product and service redirects to main domain
  {
    from: "/product/wordpress-bug-fixing",
    to: "https://moizwp.com/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/smart-restaurant-system",
    to: "https://moizwp.com/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/epicretrohub-com",
    to: "https://moizwp.com/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/search-engine-optimization",
    to: "https://moizwp.com/shopify-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/wordpress-theme-customization",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/website-design",
    to: "/website-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/website-design/",
    to: "/website-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/mern-stack",
    to: "/mern-stack-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/mern-stack/",
    to: "/mern-stack-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/price-comparison-website",
    to: "https://moizwp.com/price-comparison-website-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/price-comparison",
    to: "/price-comparison-website-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/price-comparison/",
    to: "/price-comparison-website-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/law-firms",
    to: "/law-firm-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/law-firms/",
    to: "/law-firm-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/real-estate",
    to: "/real-estate-ai-representation-infrastructure",
    status: 301,
    permanent: true,
  },
  {
    from: "/real-estate/",
    to: "/real-estate-ai-representation-infrastructure",
    status: 301,
    permanent: true,
  },
  {
    from: "/real-estate-website-design",
    to: "/real-estate-ai-representation-infrastructure",
    status: 301,
    permanent: true,
  },
  {
    from: "/real-estate-ai-infrastructure-representation",
    to: "/real-estate-ai-representation-infrastructure",
    status: 301,
    permanent: true,
  },
  {
    from: "/nonprofit",
    to: "/nonprofit-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/nonprofit/",
    to: "/nonprofit-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/industrial",
    to: "/industrial-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/industrial/",
    to: "/industrial-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/home-services",
    to: "/websites-for-home-service-businesses",
    status: 301,
    permanent: true,
  },
  {
    from: "/home-services/",
    to: "/websites-for-home-service-businesses",
    status: 301,
    permanent: true,
  },
  {
    from: "/advocate-office-management-system",
    to: "https://moizwp.com/law-firm-website-design",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/wordpress-api-integration",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/custom-plugin-development",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product-category/wordpress-services",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/wordpress-security-services",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/wordpress-website-maintenance-support",
    to: "https://moizwp.com/website-development/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/ecommerce-solutions-with-woocommerce",
    to: "https://moizwp.com/ecommerce/",
    status: 301,
    permanent: true,
  },
  {
    from: "/product/custom-social-media-post-designs",
    to: "https://moizwp.com/",
    status: 301,
    permanent: true,
  },
  // Blog redirects (disabled to allow local /blog archive during development)
  {
    from: "/category/how-tos",
    to: "https://moizwp.com/",
    status: 301,
    permanent: true,
  },
  // Redirect old subscription URL to new one
  {
    from: "/woocommerce-subscription",
    to: "/moiz-subscriptions-pro",
    status: 301,
    permanent: true,
  },
  // Redirect old local-seo URL to shopify-development
  {
    from: "/local-seo",
    to: "/shopify-development",
    status: 301,
    permanent: true,
  },
  {
    from: "/local-seo/",
    to: "/shopify-development",
    status: 301,
    permanent: true,
  },
  // Add more redirects as needed
];

// Full URL redirects for already indexed pages
export const fullUrlRedirects: Record<string, string> = {
  "https://www.moizwordpress.com/product/wordpress-bug-fixing/":
    "https://moizwp.com/",
  "https://www.moizwordpress.com/smart-restaurant-system/":
    "https://moizwp.com/",
  "https://www.moizwordpress.com/product/epicretrohub-com/":
    "https://moizwp.com/",
  "https://www.moizwordpress.com/product/search-engine-optimization/":
    "https://moizwp.com/",
  "https://www.moizwordpress.com/product/wordpress-theme-customization/":
    "https://moizwp.com/",
  "https://www.moizwordpress.com/product/price-comparison-website/":
    "https://moizwp.com/price-comparison-website-development",
  "https://www.moizwordpress.com/advocate-office-management-system/":
    "https://moizwp.com/law-firms/",
  "https://www.moizwordpress.com/product/wordpress-api-integration/":
    "https://moizwp.com/website-development/",
  "https://www.moizwordpress.com/product/custom-plugin-development/":
    "https://moizwp.com/website-development/",
  "https://www.moizwordpress.com/product-category/wordpress-services/":
    "https://moizwp.com/website-development/",
  "https://www.moizwordpress.com/product/wordpress-security-services/":
    "https://moizwp.com/website-development/",
  "https://www.moizwordpress.com/product/wordpress-website-maintenance-support/":
    "https://moizwp.com/website-development/",
  "https://www.moizwordpress.com/product/ecommerce-solutions-with-woocommerce/":
    "https://moizwp.com/ecommerce/",
  "https://www.moizwordpress.com/product/custom-social-media-post-designs/":
    "https://moizwp.com/website-development/",
  "https://blog.moizwordpress.com/": "https://moizwp.com/blog/",
  "https://blog.moizwordpress.com/category/how-tos/": "https://moizwp.com/",
  "https://www.moizwordpress.com/woocommerce-subscription/":
    "https://moizwp.com/moiz-subscriptions-pro/",
  "https://moizwordpress.com/woocommerce-subscription/":
    "https://moizwp.com/moiz-subscriptions-pro/",
};

// Helper function to get redirect rule
export const getRedirectRule = (pathname: string): RedirectRule | null => {
  return redirectRules.find((rule) => rule.from === pathname) || null;
};

// Helper function to check if path needs redirect
export const needsRedirect = (pathname: string): boolean => {
  return redirectRules.some((rule) => rule.from === pathname);
};

// Helper function to check if current domain needs redirect
export const shouldRedirectDomain = (): boolean => {
  const currentHost = window.location.host;
  return (
    currentHost !== "moizwp.com" &&
    (currentHost.startsWith("www.moizwp.com") ||
      currentHost.startsWith("www.moizwordpress.com") ||
      currentHost.startsWith("blog.moizwordpress.com") ||
      currentHost.includes("moizwordpress.com"))
  );
};

// Helper function to get main domain redirect
export const getMainDomainRedirect = (): string => {
  const pathname = window.location.pathname;
  const search = window.location.search;

  // If the host is blog.moizwordpress.com, we should redirect to the /blog subpath
  if (window.location.host.startsWith("blog.moizwordpress.com")) {
    const cleanPath = pathname.replace(/^\/blog/, "");
    return `https://moizwp.com/blog${cleanPath}${search}`;
  }

  return `https://moizwp.com${pathname}${search}`;
};

// Helper function to check if current full URL needs redirect
export const shouldRedirectFullUrl = (): boolean => {
  const currentUrl = window.location.href;
  return fullUrlRedirects.hasOwnProperty(currentUrl);
};

// Helper function to get redirect for current full URL
export const getFullUrlRedirect = (): string | null => {
  const currentUrl = window.location.href;
  return fullUrlRedirects[currentUrl] || null;
};
